<template>
    <div>
        <div class="md-layout md-gutter">
            <div class="md-layout-item md-size-50">
                <md-card>
                    <md-card-header class="md-card-header-icon" :class="'md-card-header-' + color">
                        <div class="md-layout">
                            <div class="md-layout-item">
                                <div class="card-icon">
                                    <font-awesome-icon class="md-icon" :icon="['fa', 'info']" />
                                </div>
                                <h4 class="title">
                                    Détails de la demande créee par {{ demand.creator.first_name }}
                                    - <span class="font-medium" :class="demand.status === 0 ? 'text-danger' : demand.status === 1 ? 'text-success' : 'text-warning'">{{ status() }}</span>
                                </h4>
                            </div>
                            <div class="md-layout-actions md-layout-item md-size-10 text-right align-center mt-2" v-if="demand.status === 0">
                                <div class="flex items-center justify-end header-actions">
                                    <div>
                                        <md-button class="md-icon-button md-raised md-warning"
                                            @mousedown="goToRoute($event,'Demand Edit', { demandId: demand.id })">
                                            <font-awesome-icon class="md-icon" :icon="['fa', 'pen']" />
                                        </md-button>
                                        <md-tooltip md-direction="top">Modifier</md-tooltip>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </md-card-header>
                    <md-card-content>
                        <div>
                            <div class="md-layout">
                                <div class="md-layout-item md-size-45">
                                    <span class="font-bold">Date :</span>
                                    {{ $moment(demand.date).format('DD/MM/YYYY - HH:mm') }}
                                </div>
                            </div>
                            <div class="md-layout">
                                <div class="md-layout-item md-size-50">
                                    <span class="font-bold">Client :</span>
                                    <span v-if="demand.client" class="text-info cursor-pointer" @mousedown="goToRoute($event,'Client Details', { id: demand.client.id })">
                                    {{ demand.client.name }}
                                </span>
                                    <span v-else class="ml-1">Ø</span>
                                </div>
                                <div class="md-layout-item md-size-50">
                                    <span class="font-bold">Site :</span>
                                    <span v-if="demand.site" class="text-info cursor-pointer" @mousedown="goToRoute($event,'Site Details', { id: demand.client.id, idSite: demand.site.id })">
                                        {{ demand.site.name }}
                                    </span>
                                    <span v-else class="ml-1">Ø</span>
                                </div>
                            </div>
                            <div class="md-layout" v-if="!demand.client">
                                <div class="md-layout-item md-size-100">
                                    <span class="font-bold">Prospect :</span>
                                    <span class="ml-1">{{ demand.prospect }}</span>
                                </div>
                            </div>
                            <div class="md-layout">
                                <div class="md-layout-item md-size-100">
                                    <span class="font-bold">Type(s) de demande :</span>
                                    <template v-if="demand.demand_types.length > 0">
                                        {{ demand.demand_types.map(type => type.name).join(' - ') }}
                                    </template>
                                    <span v-else class="ml-1">Aucun type selectionné</span>
                                </div>
                            </div>
                            <div class="md-layout mt-4">
                                <div class="md-layout-item md-size-100">
                                    <p class="leading-4">
                                        <span class="font-bold">Sujet :</span>
                                        {{ demand.subject }}
                                    </p>
                                </div>
                            </div>
                            <div class="md-layout mt-1">
                                <div class="md-layout-item md-size-100">
                                    <span class="font-bold">Message :</span>
                                    <p class="leading-4 -mt-1" id="demand-message"></p>
                                </div>
                            </div>
                        </div>
                    </md-card-content>
                    <md-card-actions md-alignment="space-between">
                        <md-button class="md-warning md-dense" v-if="demand.status === 0"
                                   @click="updateStatus(10)">
                            <span class="font-medium">Mettre en attente</span>
                        </md-button>
                        <md-button class="md-warning md-dense" v-if="demand.status === 1 || demand.status === 10"
                                   @click="updateStatus(0)">
                            <span class="font-medium">Ré-ouvrir cette demande</span>
                        </md-button>
                        <md-button class="md-success md-dense" v-if="!hasTasksInPending && (demand.status === 0 || demand.status === 10)"
                                   @click="updateStatus(1)">
                            <span class="font-medium">Fermer cette demande</span>
                        </md-button>
                    </md-card-actions>
                </md-card>
                <md-card style="margin-top: 40px;">
                    <md-card-header class="md-card-header-icon md-card-header-blue">
                        <div class="md-layout">
                            <div class="md-layout-item">
                                <div class="card-icon">
                                    <font-awesome-icon class="md-icon" :icon="['fa', 'comments']" />
                                </div>
                                <h4 class="title">Commentaires</h4>
                            </div>
                        </div>
                    </md-card-header>
                    <md-card-content>
                        <template v-if="demand.comments.length > 0">
                            <div v-for="(comment, index) in demand.comments" :key="'comment-' + comment.id" class="demand-comment">
                                <demand-comment-row :comment="comment" :canEdit="demand.status === 0" @updated="getDemandDetails"></demand-comment-row>
                                <md-divider class="my-3" v-if="(index + 1) !== demand.comments.length"></md-divider>
                            </div>
                        </template>
                        <p v-else>Aucun commentaire lié à cette demande.</p>
                        <template v-if="demand.status === 0">
                            <md-divider class="mt-4"></md-divider>
                            <div class="mt-3">
                                <p class="font-bold">Ajouter un commentaire</p>
                                <form ref="add_demand_comment_form" @submit.prevent="addComment">
                                    <div class="mt-2">
                                        <md-field class="md-invalid">
                                            <label>Commentaire</label>
                                            <md-textarea v-model="comment" name="comment" required md-autogrow></md-textarea>
                                            <validation-error :errors="apiValidationErrors.comment" />
                                        </md-field>
                                    </div>
                                    <div class="mt-2">
	                                    <md-button class="md-icon-button md-raised md-success" type="submit" :disabled="waiting.comment">
		                                    <font-awesome-icon class="md-icon" :icon="['fa', waiting.comment ? 'sync-alt' : 'plus-circle']" :class="{'animate-spin': waiting.comment}"></font-awesome-icon>
		                                    <span class="leading-none font-medium ml-2"> Ajouter</span>
	                                    </md-button>
                                    </div>
                                </form>
                            </div>
                        </template>
                    </md-card-content>
                </md-card>
            </div>
            <div class="md-layout-item md-size-50">
                <md-card>
                    <md-card-header class="md-card-header-icon md-card-header-blue">
                        <div class="md-layout">
                            <div class="md-layout-item">
                                <div class="card-icon">
                                    <font-awesome-icon class="md-icon" :icon="['fa', 'list']" />
                                </div>
                                <h4 class="title">Actions liées</h4>
                            </div>
                        </div>
                    </md-card-header>
                    <md-card-content>
                        <template v-if="demand.tasks.length > 0">
                            <p class="font-bold mb-2">Actions en attente</p>
                            <template v-if="demand.tasks.filter(t => { return !t.is_done }).length > 0">
                                <demand-task-row v-for="task in demand.tasks.filter(t => { return !t.is_done })" :key="'task-' + task.id" :task="task"
                                                 :canEdit="demand.status === 0" :demandId="demand.id"
                                                 @updated="getDemandDetails" @task-validate="getDemandDetails"></demand-task-row>
                            </template>
                            <p v-else>Aucune action en attente</p>
                            <md-divider class="mt-2"></md-divider>
                            <p class="font-bold my-2">Actions terminées</p>
                            <template v-if="demand.tasks.filter(t => { return t.is_done }).length > 0">
                                <demand-task-row v-for="task in demand.tasks.filter(t => { return t.is_done })" :key="'task-' + task.id" :task="task"
                                                 :canEdit="demand.status === 0" @updated="getDemandDetails"></demand-task-row>
                            </template>
                            <p v-else class="-mb-2 -mt-2">Aucune action terminée</p>
                        </template>
                        <p v-else>Aucune action liée à cette demande.</p>
                        <template v-if="demand.status === 0">
                            <md-divider class="mt-3.5"></md-divider>
                            <div class="mt-2.5">
                                <p class="font-bold">Ajouter une action</p>
                                <form ref="add_task_form" @submit.prevent="addTask">
                                    <div class="md-layout mt-2">
                                        <div class="md-layout-item md-size-50">
                                            <div class="md-multiselect">
                                                <label>Utilisateur *</label>
                                                <multiselect
                                                    v-model="task.user"
                                                    :options="users"
                                                    placeholder="Utilisateur"
                                                    :option-height="104"
                                                    track-by="id"
                                                    label="first_name"
                                                    openDirection="bottom"
                                                    :show-labels="false">
                                                    <template slot="noOptions">La liste est vide</template>
                                                    <template slot="noResult">Aucun élement correspondant</template>
                                                </multiselect>
                                            </div>
                                        </div>
                                        <div class="md-layout-item md-size-50">
                                            <div class="md-multiselect">
                                                <label>Type de demande *</label>
                                                <multiselect
                                                    v-model="task.demandType"
                                                    :options="demandTypes"
                                                    placeholder="Type de demande"
                                                    :option-height="104"
                                                    track-by="id"
                                                    label="name"
                                                    openDirection="bottom"
                                                    :show-labels="false">
                                                    <template slot="noOptions">La liste est vide</template>
                                                    <template slot="noResult">Aucun élement correspondant</template>
                                                </multiselect>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="md-layout mt-2">
                                        <div class="md-layout-item md-size-100">
                                            <md-field class="md-invalid">
                                                <label>Texte</label>
                                                <md-textarea v-model="task.text" name="text" md-autogrow required></md-textarea>
                                                <validation-error :errors="apiValidationErrors.text" />
                                            </md-field>
                                        </div>
                                    </div>
                                    <div class="mt-3">
	                                    <md-button class="md-icon-button md-raised md-success" type="submit" :disabled="waiting.task">
		                                    <font-awesome-icon class="md-icon" :icon="['fa', waiting.task ? 'sync-alt' : 'plus-circle']" :class="{'animate-spin': waiting.task}"></font-awesome-icon>
		                                    <span class="leading-none font-medium ml-2">Ajouter</span>
	                                    </md-button>
                                    </div>
                                </form>
                            </div>
                        </template>
                    </md-card-content>
                </md-card>
                <md-card style="margin-top: 40px;" v-if="demand.status === 0">
                    <form ref="mail_task_form" @submit.prevent="sendMail">
                        <md-card-header class="md-card-header-icon md-card-header-blue">
                            <div class="md-layout">
                                <div class="md-layout-item">
                                    <div class="card-icon">
                                        <font-awesome-icon class="md-icon" :icon="['fa', 'male']" />
                                    </div>
                                    <h4 class="title">Techniciens</h4>
                                </div>
                            </div>
                        </md-card-header>
                        <md-card-content>
                            <div>
                                <label class="font-medium">Destinataire(s)</label>
                                <div class="flex items-center flex-wrap">
                                    <div class="mr-2" v-for="tech in technicians" :key="'tech-' + tech.id">
                                        <md-checkbox v-model="email.recipients" :value="tech" class="mt-2 mb-0">{{ tech.full_name }}</md-checkbox>
                                    </div>
                                </div>
                            </div>
                            <md-field class="md-invalid mt-4">
                                <label>Message</label>
                                <md-textarea v-model="email.message" name="message" required></md-textarea>
                                <validation-error :errors="apiValidationErrors.message" />
                            </md-field>
                        </md-card-content>
                        <md-card-actions md-alignment="left">
	                        <div>
		                        <md-button class="md-icon-button md-raised md-success" type="submit" :disabled="email.sending">
			                        <font-awesome-icon class="md-icon" :icon="['fa', email.sending ? 'sync-alt' : 'paper-plane']" :class="{'animate-spin': email.sending}"></font-awesome-icon>
			                        <span class="leading-none font-medium ml-2"> Envoyer</span>
		                        </md-button>
	                        </div>
                        </md-card-actions>
                    </form>
                </md-card>
            </div>
        </div>
    </div>
</template>

<script>
// Components
import DemandCommentRow from "@/pages/Demands/components/DemandCommentRow";
import DemandTaskRow from "@/pages/Demands/components/DemandTaskRow";
import { ValidationError } from "@/components";

// Mixins
import formMixin from "@/mixins/form-mixin";
import routerMixin from "@/mixins/router-mixin"

// Vuex
import { mapState } from "vuex";

export default {
    name: "DemandDetails",
    components: {ValidationError, DemandCommentRow, DemandTaskRow },
    mixins: [formMixin, routerMixin],
    data() {
        return {
            color: 'blue',
            demand: {
                demand_types: [],
                tasks: [],
                comments: [],
                creator: {}
            },
            comment: '',
            task: {
                user: null,
                demandType: null,
                text: null,
            },
            email: {
                sending: false,
                recipients: [],
                message: '',
            },
            users: [],
            demandTypes: [],
            technicians: [],
	        waiting: {
				comment: false,
		        task: false
	        }
        }
    },
    computed: mapState({
        me: state => state.profile.me,
        hasTasksInPending() {
            return !!this.demand.tasks.find(task => task.is_done === 0)
        },
    }),
    methods: {
        async getDemandDetails() {
            const { data } = await this.$store.dispatch('demands/getDemandDetails', {
                demandId: this.$route.params.demandId
            })
            this.demand = data
            this.color = data.status === 0 ? 'danger' : (data.status === 1 ? 'green' : 'warning')
        },
        async getUsers() {
            const { data } = await this.$store.dispatch('users/fetchActive')
            this.users = data
        },
        async getDemandTypes() {
            const { data } = await this.$store.dispatch('demandTypes/getDemandTypes')
            this.demandTypes = data
        },
        async getTechnicians() {
            const { data } = await this.$store.dispatch('users/getTechnicians', {
                isActive: true,
                order: 'last_name'
            })
            data.push({
                id: -1,
                full_name: 'Experts',
                email: 'experts@gmd-sanitation.com'
            })
            this.technicians = data
        },
        async addComment() {
			this.waiting.comment = true
            this.resetApiValidation()
            try {
                await this.$store.dispatch('demandComments/addDemandComment', {
                    demand_id: this.demand.id,
                    comment: this.comment
                })
                await this.$store.dispatch('alerts/success', 'Commentaire ajouté')
                this.comment = ''
	            this.waiting.comment = false
                await this.getDemandDetails()
            } catch (e) {
                this.setApiValidation(e.response.data.errors)
            }
        },
        async updateStatus(status) {
            try {
                await this.$store.dispatch('demands/updateDemandStatus', {
                    demandId: this.demand.id,
                    status: status
                })
                const msg = status === 0 ? 'Demande ré-ouverte' : (status === 1 ? 'Demande cloturée' : 'Demande mise en attente')
                await this.$store.dispatch('alerts/success', msg)
                await this.getDemandDetails()
            } catch (e) {
            }
        },
        async addTask() {
			this.waiting.task = true
            this.resetApiValidation()
            try {
                await this.$store.dispatch('demandTasks/addDemandTask', {
                    demand_id: this.demand.id,
                    user_id: this.task.user.id,
                    type_id: this.task.demandType.id,
                    text: this.task.text
                })
                await this.$store.dispatch('alerts/success', 'Action ajoutée')
	            this.task = {
		            user: null,
		            demandType: null,
		            text: null
	            }
	            this.waiting.task = false
                await this.getDemandDetails()
            } catch (e) {
                if (e.response) {
                    this.setApiValidation(e.response.data.errors)
                }
            }
        },
        async sendMail() {
            if(this.email.recipients.length > 0) {
                this.email.sending = true
                try {
                    await this.$store.dispatch('demands/sendMailToTechnicians', {
                        demandId: this.demand.id,
                        recipients: this.email.recipients.map(recip => recip.id),
                        message: this.email.message
                    })
                    await this.$store.dispatch('alerts/success', 'Un message a été envoyé au(x) technicien(s)')
                } catch (e) {
                }
                this.email.sending = false
            } else {
                await this.$store.dispatch('alerts/warning', 'Veuillez selectionner au moins 1 destinataire')
            }
        },
        formatMailMessage() {
            this.email.message = _.cloneDeep(this.demand.message) + '\n\nMerci. ' + this.me.first_name
        },
        status() {
            return this.demand.status === 0 ? 'Non traitée' : (this.demand.status === 1 ? 'Traitée' : 'En attente')
        },
        nl2br(str, replaceMode, isXhtml) {
            let breakTag = (isXhtml) ? '<br />' : '<br>';
            let replaceStr = (replaceMode) ? '$1'+ breakTag : '$1'+ breakTag +'$2';
            return (str + '').replace(/([^>\r\n]?)(\r\n|\n\r|\r|\n)/g, replaceStr);
        },
    },
    mounted() {
        this.getDemandDetails()
        this.getUsers()
        this.getDemandTypes()
        this.getTechnicians()
    },
    watch: {
        'demand.message'(newVal) {
            if(newVal) {
                document.getElementById('demand-message').innerHTML = this.nl2br(newVal)
                this.formatMailMessage()
            }
        },
        me(newVal) {
            if(newVal) {
                this.formatMailMessage()
            }
        }
    }
}
</script>

<style scoped lang="scss">
.md-layout.md-gutter {
    margin: 0;
    .md-layout-item {
        padding: 0 10px;

        &:first-child {
            padding-left: 0;
        }

        &:last-child {
            padding-right: 0;
        }
    }
}
.creator-cube {
    width: 12px;
    height: 12px;
    border-radius: 3px;
}
</style>
